import { connectInternalApi } from 'common/api'

export type Industry = {
  _id: string
  name: string
  created: Date
  last_updated: Date
}

export const getAllIndustries = async (): Promise<Industry[]> => {
  const result = await connectInternalApi.get<{ data: Industry[] }>(
    'v1/core/monorail/industries'
  )
  return result.data.data
}
